<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="800"
      scrollable
      persistent
    >
      <PatientStoryForm
        :patient-story="editedPatientStory"
        :errors="patientStoryValidationErrors"
        :disabled="savingPatientStory"
        @clear:errors="clearPatientStoryValidationErrors"
        @cancel="$router.push({ name: 'patientStory' })"
        @save="onSave"
        @preview="onPreview"
        @upload:image="onImageUpload"
        @delete:image="onImageDelete"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapErrorsToInputs } from '@/util/forms.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import PatientStoryForm from '../../components/PatientStoryForm';
import store from '../../store';

export default {
  name: 'EditPatientStory',

  components: { PatientStoryForm },

  computed: mapState('patientStory', [
    'editedPatientStory',
    'patientStoryValidationErrors',
    'savingPatientStory',
  ]),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('patientStory/editPatientStory', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'patientStory' });
      });
  },

  methods: {
    ...mapActions('patientStory', [
      'updatePatientStory',
      'clearPatientStoryValidationErrors',
      'uploadPatientStoryImages',
      'deletePatientStoryImages',
    ]),
    ...mapMutations('patientStory', ['SET_PATIENT_STORY_VALIDATION_ERRORS']),

    onImageUpload(images, type, modelType, modelId) {
      this.uploadPatientStoryImages({
        images,
        type,
        modelType,
        modelId,
      }).catch((err) => {
        const errors = mapErrorsToInputs(err);
        this.SET_PATIENT_STORY_VALIDATION_ERRORS({
          ...this.patientStoryValidationErrors,
          ...errors,
        });
        throw err;
      });
    },

    onImageDelete(image) {
      this.deletePatientStoryImages(image);
    },

    onSave(story) {
      this.updatePatientStory(story).then(() => {
        this.$router.push({ name: 'patientStory' });
      });
    },

    onPreview(story) {
      this.updatePatientStory(story).then(() => {
        window.open(this.$previewBackendUrl(`istorijos/${story.id}`));
      });
    },
  },
};
</script>
